import { Helmet } from "react-helmet"
import Layout from "../components/layout/Layout"
import TeamDetails1 from "../components/sections/TeamDetails1"

import { Autoplay, Navigation, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import ContactSection1 from "../components/sections/contact/ContactSection1"

const swiperOptions = {
	modules: [Autoplay, Pagination, Navigation],
	spaceBetween: 30,
	speed: 2500,
	loop: true,
	autoplay: {
		delay: 2500,
		disableOnInteraction: false,
	},
	breakpoints: {
		1199: {
			slidesPerView: 5,
		},
		991: {
			slidesPerView: 4,
		},
		767: {
			slidesPerView: 3,
		},
		575: {
			slidesPerView: 2,
		},
		0: {
			slidesPerView: 1,
		},
	},
}
export default function DealersAndDistribution() {
	return (
		<>
			<Helmet>
				<title>V-Make WPC | Dealers & Distribution</title>
				<meta name="description" content="Connect with V-Make's extensive dealer and distribution network. Discover opportunities to partner with a leading brand in WPC doors, frames, and boards." />
				<meta name="keywords" content="V-Make dealers, WPC Dealers & Distribution, become a WPC dealer, WPC supplier network, WPC channel partners, WPC dealer registration, pan-India WPC dealers, WPC foam board distributors, WPC printed doors suppliers" />
				<link rel="canonical" href="https://vmakewpc.com/dealers-and-distribution" />
				<meta property="og:title" content="Dealers & Distribution | V-Make WPC" />
				<meta property="og:description" content="Join our dealer network and grow with V-Make – a trusted name in innovative, eco-friendly WPC building solutions." />
				<meta property="og:url" content="https://vmakewpc.com/dealers-and-distribution" />
				<meta property="og:image" content="https://vmakewpc.com/assets/img/team/Team_1.png" />
			</Helmet>
			<Layout headerStyle={1} footerStyle={1} >
				<TeamDetails1 />
				<ContactSection1 />
			</Layout>
		</>
	)
}
